// polyfills needed for IE 11 support
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';

import React from 'react';
import ReactDOM from 'react-dom';

import { addLocales } from 'portfolio-shared/util/addLocales';
import { initLocalStorage } from 'portfolio-shared/util/persistenceUtils';
import { loadPersistedData } from 'state/commands/persistCommands';
import { STORAGE_KEY } from 'util/constants';
import { getLocale } from 'state/selectors';
import { setMessages } from 'state/commands/intlCommands';

import 'react-virtualized/styles.css';
import 'font-awesome/css/font-awesome.css';
import './bulma-styles.css';
import './index.css';
import 'portfolio-shared/view/Utilities/BrowseServerFolders.css';
import App from 'view/App/App';
import storeManager from 'state/store/storeManager';

const store = storeManager();
// Add locales and render app once complete
addLocales(async () => {
  initLocalStorage(STORAGE_KEY);
  await store.dispatch(loadPersistedData());
  const locale = getLocale(store.getState());
  await store.dispatch(setMessages(locale));
  ReactDOM.render(<App store={store} />, document.getElementById('root'));
});



// WEBPACK FOOTER //
// ./src/index.js